// extracted by mini-css-extract-plugin
module.exports = {"annotation":"FileViewerPage-styles-module--annotation--3TjTV","disabled":"FileViewerPage-styles-module--disabled--1P06g","button":"FileViewerPage-styles-module--button--37WTv"};